import { Component, OnInit, inject } from '@angular/core';
import { IReview } from './models/review.interface';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '@shared/module/shared.module';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BaseComponent } from '@shared/components/base/base.component';
import { LikesService } from '@shared/service/http_services/like.service';
import { CreateLikeModel } from '@shared/model/customerModels/like-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ReviewItemComponent } from './components/review-item/review-item.component';
import { HeaderActionTypeEnum, HeaderComponent, HeaderConfigModel } from '@shared/components/header/header.component';
import { ReviewsAggrigatorService } from '@app/pages/reviews/services/reviewsAggrigator.service';
import { GetUserDataPipe } from '@shared/components/User-Activity-Info/pipes/get-user-data/get-user-data.pipe';
import { BehkhaanBookCardComponent } from '@app/pages/books/components/behkhaan-book-card/behkhaan-book-card.component';
import { ActivityLikedUsersComponent } from '@shared/components/activity-liked-users/activity-liked-users.component';
import { UserActivityInfoComponent } from '@shared/components/User-Activity-Info/user-activity-info/user-activity-info.component';
import { ActivityFooterPluseComponent } from '@shared/components/Activities/activity-footer-pluse/activity-footer-plus.component';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, takeUntil } from 'rxjs/operators';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { htmlUrls } from '@shared/utils/router-paths';
import { FooterItemPipe } from '@shared/components/Activities/pipes/footer-item.pipe';

import { LocalRepository } from '@shared/helper/local-repository';
import { BookmarkHandlerService, CreateBookmarkModel } from '@shared/service/http_services/handler/bookmark-handler.service';

@Component({
    selector: 'app-reviews',
    imports: [
        SharedModule,
        FooterItemPipe,
        GetUserDataPipe,
        HeaderComponent,
        ReviewItemComponent,
        InfiniteScrollModule,
        UserActivityInfoComponent,
        BehkhaanBookCardComponent,
        ActivityFooterPluseComponent,
    ],
    templateUrl: './reviews.component.html',
    styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent extends BaseComponent implements OnInit {
  private router = inject(Router);
  private _dialog = inject(MatDialog);
  private likesService = inject(LikesService);
  private _bottomSheet = inject(MatBottomSheet);
  private activatedRoute = inject(ActivatedRoute);
  private _localRepository = inject(LocalRepository);
  private bookmarkHandlerService = inject(BookmarkHandlerService);
  private reviewsAggrigatorService = inject(ReviewsAggrigatorService);


  headerConfig: HeaderConfigModel = {
    title: 'یادداشت‌ها'
  };

  termFilter = new TermFilterModel(0, 20)
  loading = true;
  hasMoreReview!: boolean;
  reviews!: IReview[];
  justRatesTermFilter = new TermFilterModel(0, 20);
  hasMoreRates!: boolean;
  rates!: IReview[];
  totalRateCount!: number;
  reviewActorName!: string;
  userId!: string;
  totalReviewCount!: number;
  rateOrReview = 2;
  rateOrReviewTemplate = ReviewType;
  loadingMore!: boolean;
  routes = htmlUrls;


  constructor() {
    super();

  }

  ngOnInit(): void {
    const query = this.activatedRoute.snapshot.queryParams;

    if (query?.['T'] === 'all') {
      this.reviewsAggrigatorService.getChosenReviewsWithUserLiked(this.termFilter)
        .subscribe(res => {
          this.loading = false;
          if (res.hasError) return;
          this.reviews = res.result?.items;
          this.hasMoreReview = res.result?.hasNextPage;
        });
    }
    else if (query?.['T'] === 'user') {
      this.userId = query?.['id'];
      this.reviewsAggrigatorService.getGuestRates(this.userId, this.justRatesTermFilter)
        .pipe(
          switchMap(rates => {
            if (!rates.hasError && rates.result) {
              this.rates = rates.result?.items;
              this.hasMoreRates = rates.result?.hasNextPage;
              this.totalRateCount = rates.result.totalCount;
            }
            return this.reviewsAggrigatorService.getGuestReviews(this.userId, this.termFilter)
          })
        ).subscribe(reviews => {
          if (!reviews.hasError && reviews.result) {
            this.reviews = reviews.result?.items;
            this.hasMoreReview = reviews.result?.hasNextPage;
            this.totalReviewCount = reviews.result.totalCount;
            this.changeFilter(this.rateOrReview);
            this.headerConfig = {
              title: `یادداشت‌های ${this.reviews[0].actor?.fullName} (${this.totalReviewCount})`,
              hasAction: true,
              actionList: [HeaderActionTypeEnum.reviews, HeaderActionTypeEnum.rates, HeaderActionTypeEnum.copyLink]
            }
          }

          this.loading = false;
        });
    }
  }

  changeFilter(type: number) {
    this.rateOrReview = type;
    if (type === 1) {
      this.headerConfig = {
        title: `امتیازهای ${this.reviews[0].actor?.fullName} (${this.totalRateCount})`,
        hasAction: true,
        actionList: [HeaderActionTypeEnum.reviews, HeaderActionTypeEnum.rates, HeaderActionTypeEnum.copyLink]
      }
    }
    else {
      this.headerConfig = {
        title: `یادداشت‌های ${this.reviews[0].actor?.fullName} (${this.totalReviewCount})`,
        hasAction: true,
        actionList: [HeaderActionTypeEnum.reviews, HeaderActionTypeEnum.rates, HeaderActionTypeEnum.copyLink]
      }
    }
  }

  openUsersDialog(itemId: string) {
    this.utilFunctions.peopleLiked(itemId, this._bottomSheet, this._dialog, this._localRepository, ActivityLikedUsersComponent);
  }

  likeItem(likedObject: CreateLikeModel) {
    if (!this.currentUser?.uniqeName && !this.currentUser?.firstName) {
      this.utilFunctions.opensigninDialog(this._dialog, '/', this._localRepository);
      return
    }
    this.likesService.createLike(likedObject, this.currentUser?.id!).subscribe();
  }

  loadMore() {
    // ? Load Rate
    if (this.rateOrReview === 1) {
      if (this.hasMoreRates) {
        this.loadingMore = true;
        this.justRatesTermFilter.pgNumber++;
        this.reviewsAggrigatorService.getGuestRates(this.userId, this.justRatesTermFilter)
          .pipe(
            takeUntil(this.unsubscribe$)
          ).subscribe(res => {
            if (!res.hasError) {
              res.result?.items.forEach(rate => {
                this.rates.push(rate)
              });
              this.hasMoreRates = res.result?.hasNextPage;
              this.loadingMore = false;
            }
          });
      }
    }
    // ? Load Review
    else {
      if (this.hasMoreReview) {
        this.loadingMore = true;
        this.termFilter.pgNumber++;
        this.reviewsAggrigatorService.getGuestReviews(this.userId, this.termFilter)
          .pipe(
            takeUntil(this.unsubscribe$)
          )
          .subscribe(res => {
            if (!res.hasError) {
              res.result?.items.forEach(review => {
                this.reviews.push(review)
              });
            }
            this.loadingMore = false;
            this.hasMoreReview = res.result?.hasNextPage;
          });
      }
    }
  }

  bookmarkItem(bookmarkData: CreateBookmarkModel,) {
    this.bookmarkHandlerService.handleBookmark(bookmarkData)
      .subscribe(res => {
        if (bookmarkData.userMarked) {
          res.hasError ? bookmarkData.object.userMarked = true : null;
        }
        else {
          res.hasError ? bookmarkData.object.userMarked = false : null;
        }
      });
  }
}

enum ReviewType {
  rate = 1,
  review
}
